<script>
import Table from 'element-ui/lib/table';

export default Table;
</script>

<style lang="scss">
/* stylelint-disable plugin/no-unsupported-browser-features */
@import '../../stylesheets/element-theme/table.css';

table.el-table__header {
  margin-bottom: 0;
}

.el-table {
  $base: &;

  &-filter {
    .el-checkbox-group {
      flex-direction: column;
    }
  }

  table {
    margin-bottom: 0;
    border-collapse: separate;
  }

  td,
  th {
    // overrriding the zurb foundation '.is-hidden' style
    // which is messing the element-ui columns having the same class
    display: table-cell !important;

    @include rtl() {
      text-align: right;

      &.is-left {
        text-align: left;
      }

      &.is-center {
        text-align: center;
      }

      &:not(.is-center):first-child {
        padding-right: $global-padding;
      }
    }

    .cell {
      word-break: keep-all;
    }

    &:not(.is-center):first-child {
      padding-left: $global-padding;
      @include rtl() {
        padding-left: 0;
        padding-right: $global-padding;
      }
    }

    &:last-child {
      padding-right: $global-padding;
      @include rtl() {
        padding-right: 0;
        padding-left: $global-padding;
      }
    }
  }

  &__expand-icon > .el-icon-arrow-right {
    font-weight: bold;
  }

  @include rtl() {
    &__expand-icon {
      transform: rotate(180deg);

      &--expanded {
        transform: rotate(90deg);
      }
    }
  }

  .caret-wrapper {
    margin-left: 0.5rem;

    @include rtl() {
      margin-left: 0;
      margin-right: 0.5rem;
      order: 1;
    }

    @include breakpoint(small only) {
      display: none;
    }
  }

  th {
    > .cell {
      display: flex;
      align-items: center;
    }

    &.is-center > .cell {
      justify-content: center;
    }
  }

  @include rtl() {
    &__body-wrapper.is-scrolling-left {
      ~ #{$base}__fixed {
        box-shadow: $--table-fixed-box-shadow;
      }
    }

    &__body-wrapper.is-scrolling-right {
      ~ #{$base}__fixed {
        box-shadow: 0 0 0;
      }
    }

    .cell__wrapper {
      direction: rtl;
      text-align: right;
    }

    &::before {
      left: auto;
      right: 0;
    }

    &::after {
      right: auto;
      left: 0;
    }

    /*&--fit {*/
    /*border-right: 1px solid #e0e6ed;*/
    /*border-left: 0;*/
    /*}*/

    &__fixed {
      left: auto;
      right: 0;
      pointer-events: none;

      & > div {
        pointer-events: all;
      }

      &::before {
        left: auto;
        right: 0;
      }

      &-right::before {
        left: auto;
        right: 0;
      }

      &-header-wrapper {
        left: auto;
        right: 0;
      }

      &-body-wrapper {
        left: auto;
        right: 0;
      }
    }

    &--border th {
      border-left: 0;
      border-right: 1px solid #e0e6ed;
    }

    &:not([dir]) th:not(.is-center) {
      text-align: right;
    }

    &__column-resize-proxy {
      left: auto;
      right: 200px;
      border-left: 0;
      border-right: 1px solid #e0e6ed;
    }
  }

  &__header-title {
    padding-top: 0.35rem;
    padding-bottom: 0.35rem;
    vertical-align: middle;
    white-space: normal;
    display: flex;
    flex-direction: column;

    @include rtl() {
      direction: rtl;
      order: 2;
    }

    @include breakpoint(medium) {
      max-width: calc(100% - 30px);
    }
  }

  &__all-apps {
    margin-top: 0.35rem;
    font-style: normal;
    font-weight: normal;
    padding: 0 !important;

    $q: &;

    // dirty hack to override the ElementUI style
    // w/o using any other selectors
    &-btn#{$q}-btn {
      color: $asbestos;
    }
  }
}
</style>
